import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { makeStyles } from "@material-ui/core/styles";
import Navbar from "../Components/Navbars/Navbar";
import Footer from "../Components/Footer/Footer.js";
import Sidebar from "../Components/Sidebar/Sidebar.js";
import routesIn from "../routes.js";
import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import logo from "../assets/img/logo.jpeg";
import { connect } from "react-redux";
import country from "config/countryConfig";

let ps;
let role;

const switchRoutes = (role, routesIn) => (
  <Switch>
    {routesIn.map((prop, key) => {
      if (prop.layout === "/admin" && role === 'admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"adminRoute" + key}
          />
        );
      // DX-only layout — not used on Country Portal
      // } else if (prop.layout === "/master" && role === 'admin') {
      //   return (
      //     <Route
      //       path={prop.layout + prop.path}
      //       component={prop.component}
      //       key={"masterRoute" + key}
      //     />
      //   )
      } else if (prop.layout === "/panelist" && role === 'panelist') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"panelistRoutes" + key}
          />
        )
      // PM role doesn't exist on Country Portal
      // } else if (prop.layout === "/pm" && role === 'pm') {
      //   return (
      //     <Route
      //       path={prop.layout + prop.path}
      //       component={prop.component}
      //       key={"pmRoutes" + key}
      //     />
      //   )
      } else if (prop.layout === "/sub-admin" && role === 'sub-admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"subAdminRoutes" + key}
          />
        )
      } else if (prop.layout === "/finance" && role === 'finance') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={"financeRoute" + key}
          />
        )
      }
    })}
    <Redirect from="/" to={`/${role}/profile`} />
  </Switch>
);

const useStyles = makeStyles(styles);

function Admin({ ...rest }) {
  role = rest.role || 'admin'
  let routes = [];
  if (role === 'panelist') {
    routes = routesIn.filter((item) => item.layout === '/panelist' || item.type === 'panelist');
  }
  if (role === 'admin') {
    routes = routesIn.filter((item) => item.layout === '/admin' && item.type === 'admin');
  }
  // PM role doesn't exist on Country Portal
  // if (role === 'pm') {
  //   routes = routesIn.filter((item) => item.layout === '/pm' && item.type === 'pm');
  // }
  if (role === 'sub-admin') {
    routes = routesIn.filter((item) => item.layout === '/sub-admin' && item.type === 'sub-admin');
  }
  if (role === 'finance') {
    routes = routesIn.filter((item) => item.layout === '/finance' && item.type === 'finance');
  }

  const classes = useStyles();
  const mainPanel = React.createRef();
  const [color] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  React.useEffect(() => {
    // Hey! sonarqube, Please ignore this code
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps = new PerfectScrollbar(mainPanel.current, {
    //     suppressScrollX: true,
    //     suppressScrollY: false,
    //   });
    //   document.body.style.overflow = "hidden";
    // }
    const isWindows = /Win/.test(navigator.userAgent);
    if (isWindows) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }

    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      // Hey! sonarqube, Please ignore this code
      // if (navigator.platform.indexOf("Win") > -1) {
      //   ps.destroy();
      // }
      if (isWindows) {
        ps.destroy();
        document.body.style.overflow = "hidden";
      }

      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        // language={rest.language}
        logoText={role === 'admin' ? `${country.brandName} Admin` : country.brandName}
        logo={logo}
        image=""
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      {/* id="mainPanel" is a stable hook for ScrollToTop. The JSS class
          name is minified in production builds (no readable substring),
          so a class-based selector is unreliable; the id is not. This is
          the actual scrolling element (PerfectScrollbar attaches here). */}
      <div id="mainPanel" className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes(role, routes)}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes(role, routes)}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    todos: state,
    role: state.adminUser.adminUser.role,
    language: state.adminUser.adminUser.language,
  };
}

export default connect(mapStateToProps)(Admin);
